<template>
    <div class="flip-container" :class="{ hover: flip }" @mouseenter="flip = true" @mouseleave="flip = false">
        <div class="flipper">
            <div class="front card" :class="classes">
                <img v-if="course.image" class="card__bgimage" :src="course.image">
                <div class="card__body">
                    <div class="card__text">
                        <p>{{ course.title }}</p>

                        <div class="mt-xl small">
                            <p>Price (ex GST): <strong>${{ course.price }}</strong></p>
                            <p>Duration: <strong>{{ course.duration }}</strong></p>
                        </div>
                    </div>
                    
                    <div v-if="course.certificate" class="card__meta">
                        <span class="loz">Digital credential included</span>
                    </div>

                    <button @click="flip = true">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13L6.93569 7.06431L1 1" stroke="#EF6E0B" stroke-width="2" />
                        </svg>
                    </button>
                </div>
            </div>
            
            <div class="back card">
                <div class="card__body">
                    <div class="card__text">
                        <p class="small semi text--grey-light">Description</p>
                        <div class="card__desc" v-html="course.description" />
                    </div>

                    <div class="card__meta">
                        <a class="arrowlink" :href="course.url">
                            Learn more
                            <svg class="icon">
                                <use xlink:href="#arrow-right"></use>
                            </svg>
                        </a>
                    </div>

                    <button @click="flip = false">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13L6.93569 7.06431L1 1" stroke="#EF6E0B" stroke-width="2" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        course: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            flip: false,
        };
    },

    computed: {
        classes() {
            return this.course.image ? 'card--image card--white' : 'card--shadow';
        }
    },
}
</script>

<style lang="scss" scoped>
    .flip-container {
        perspective: 1000px;

        &.hover .flipper {
        // &:hover .flipper {
            transform: rotateY(180deg);
        }
    }

    .flip-container, .front, .back {
        width: 100%;
        height: 400px;
    }

    .flipper {
        transition: 0.6s;
        transform-style: preserve-3d;
        position: relative;

        .card__body {
            overflow: hidden;
            padding: 4em 2.25em;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            background-color: white;
            width: 32px;
            height: 64px;
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
            box-shadow: 0 0 3px #BBB;

            svg {
                margin-left: 12px;
            }
        }
    }

    .front, .back {
        backface-visibility: hidden;
        position: absolute;
        top: 0;
        left: 0;
    }

    .front {
        z-index: 2;
        transform: rotateY(0deg);
    }

    .back {
        transform: rotateY(180deg);
    }
</style>